import { useSelector } from 'react-redux'

import { selectCockpitAttentionPartners } from '../../../model/selectors'

/**
 * How many partners the tile's counts stand against: every partner the cockpit's filters currently
 * show. The header states it once, so no row has to carry its own `of 671`.
 *
 * The single-partner cockpit counts one partner's own statuses and has no such base, so there it
 * is `0` and the header says nothing.
 */
export const useAttentionScopeSize = (isManagerCockpitMode: boolean): number => {
  const partners = useSelector(selectCockpitAttentionPartners)

  return isManagerCockpitMode ? partners.length : 0
}
